// removed by extract-text-webpack-plugin
module.exports = {"popover":"antd-pro_-_-scaffold-src-components-NoticeIcon-popover","noticeButton":"antd-pro_-_-scaffold-src-components-NoticeIcon-noticeButton","icon":"antd-pro_-_-scaffold-src-components-NoticeIcon-icon","tabs":"antd-pro_-_-scaffold-src-components-NoticeIcon-tabs"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/NoticeIcon/index.less
// module id = 437
// module chunks = 0 1